import fetch from 'cross-fetch'
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

const httpLink = new HttpLink({
  uri: `${process.env.GATSBY_API_URL}`,
  fetch,
})

const isWindowClient = typeof window !== 'undefined'

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = isWindowClient ? localStorage.getItem('token') : ''
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token && token !== 'null' ? `Bearer ${token}` : '',
    },
  }
})

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
})
